import { UserRole } from '@mi-front/core';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PersonIcon from '@mui/icons-material/Person';
import React from 'react';

export const userRoleIconMap: Record<string, React.ReactNode> = {
  [UserRole.CLIENT_USER]: <PersonIcon color="disabled" />,
  [UserRole.CLIENT_ADMIN]: <ManageAccountsIcon color="primary" />,
};
